import { useCallback } from "react";

import { useAppDispatch, useAppSelector } from "@/hooks/redux";
import { addModalToQueue } from "@/store/slices/ui";
import { getOrderOpenedYesterdayCheckoutListThunk } from "@/store/slices/work";
import { ModalType } from "@/types";

export const useCheckYesterdayOpenCheckouts = () => {
    const { route } = useAppSelector((s) => s.user);

    const dispatch = useAppDispatch();

    const handleCheck = useCallback(async () => {
        if (!route?.uuid) return;

        try {
            const { result: yesterdayCheckoutList } = await dispatch(
                getOrderOpenedYesterdayCheckoutListThunk({
                    routeId: route.uuid,
                }),
            ).unwrap();

            if (yesterdayCheckoutList.length > 0) {
                dispatch(
                    addModalToQueue({
                        type: ModalType.YesterdayOpenedCheckouts,
                        id: ModalType.YesterdayOpenedCheckouts,
                    }),
                );
            }
        } catch (error) {
            console.error(error);
        }
    }, [dispatch, route?.uuid]);

    return { handleCheck };
};
